import React from 'react';
import SupervisorYearlySalesChart from './SupervisorYearlySalesChart';
import SupervisorCumulativeSalesChart from './SupervisorCumulativeSalesChart';
import SupervisorExpenseDoughnutChart from './SupervisorExpenseDoughnutChart';
import SupervisorRecentSales from './SupervisorRecentSales';
import SupervisorSalesDistributionChart from './SupervisorSalesDistributionChart';
import '../styles/SalesCharts.css';
import '../styles/AdminRecentSales.css';
import '../styles/AdminDashboardCharts.css';

const SupervisorDashboardCharts = ({ selectedPOS }) => {
  return (
    <div className="admin-dashboard-container">
      {/* Sección de gráficas */}
      <div className="sales-charts-container">
        {/* Gráfica de ventas mensuales (enero a diciembre) */}
        <SupervisorYearlySalesChart selectedPOS={selectedPOS} />
        
        {/* Gráfica de ventas acumuladas (enero a diciembre) */}
        <SupervisorCumulativeSalesChart selectedPOS={selectedPOS} />
        
        {/* Gráfica de distribución de las ventas por producto */}
        <SupervisorSalesDistributionChart selectedPOS={selectedPOS} />
        
        {/* Gráfica de Gastos Mensuales por Categoría */}
        <div className="chart-wrapper expense-chart-wrapper">
          <h3>Gastos Mensuales por Categoría</h3>
          <div className="chart-container expense-chart-container">
            <SupervisorExpenseDoughnutChart selectedPOS={selectedPOS} />
          </div>
        </div>
      </div>
      
      {/* Sección de tablas de datos */}
      <div className="dashboard-bottom-section">
        {/* Ventas Recientes */}
        <div className="dashboard-column full-width">
          <SupervisorRecentSales selectedPOS={selectedPOS} />
        </div>
      </div>
    </div>
  );
};

export default SupervisorDashboardCharts;
